(ns bec-core.cljs.views.layout
  (:require [reagent.core :as r]
            [re-frame.core :as rf]
            [cljs.core.async :as async]
            [cljs.core.async.interop :refer-macros [<p!]]
            [bec-core.cljs.notification :as notification]
            [bec-core.cljs.service-worker :as sw]
            ;; [bec-core.cljs.connection :as connection]
            [bec-cljs-common.utils.css :as css]
            [bec-cljs-common.components.error-modal :as error-modal]
            [bec-cljs-common.components.input :as input]
            [bec-cljs-common.components.button :as button :refer [glowing-icon-button dynamic-ul dynamic-icon-label 
                                                                  dynamic-menu-label]]
            [bec-cljs-common.components.icon :refer [icon]]
            [bec-cljs-common.components.flag-icons :as flag-icons]
            [bec-cljs-common.networking :as bec-net]
            [bec-core.cljs.components.logo :refer [app-logo]]
            [bec-core.cljs.components.lookup-data :refer [svg-map-paths]]
            [bec-core.cljs.routes :as routes]))

(defonce side-panel-active? (r/atom false))

(defonce dynamic-label-active? (r/atom false))
(defonce side-panel-focused? (r/atom nil))
(defonce dynamic-side-panel-hidden? (r/atom false))
(defonce dynamic-ul-active? (r/atom {}))
(defonce counter1 (r/atom false))

(defonce dynamic-right-side-panel-active? (r/atom {}))

(defn hamburger [& [props]]
  [:button.is-clickable.glows.hamburger
   (merge
    (when (map? props) props)
    {:type "button"
     :aria-label "Menu"
     :aria-controls "navigation"
     :style {:width "3.5rem"
             :height "3rem"
             :margin "0.25rem"
             "--is-clickable-drop-shadow-spread-1" "1.25em"
             "--is-clickable-drop-shadow-color-1" "var(--blue)"
             "--is-clickable-drop-shadow-spread-2" "0.5em"
             "--is-clickable-drop-shadow-color-2" "var(--blue)"}})
   [:span.hamburger-box
    [:span.hamburger-inner]]])

(defn delete-cross-arrow [& [props]]
  [:button.is-clickable.glows.delete-cross.delete-cross-arrow
   (merge
    (when (map? props) props)
    {:type "button"
     :aria-label "Menu"
     :aria-controls "navigation"
     :style (merge
             {:width "3.5rem"
              :height "3rem"
              :margin "0.25rem"}
             (:style props))})
   [:span.delete-cross-box
    [:span.delete-cross-inner]]])

(defn arrow-button [& [props]]
  [:button.is-clickable.glows
   (merge
     (when (map? props) (dissoc props :active?))
     {:type "button"
      :aria-expanded (if (:active? props) "true" "false")
      :aria-label "Menu"
      :aria-controls "navigation"
      :style (merge
               {:width "3.5rem"
                :height "3rem"
                :margin "0.25rem"}
               (:style props))})
   [:span.icon
    {:style {:transform (when (:active? props) "rotate(180deg)")
             :transition "transform var(--transition-duration) ease"}}
    [:i.fas.fa-arrow-right.fa-2x]]])

(defonce search-bar-active? (r/atom nil))

(defn search-bar []
  (let [window-width @(rf/subscribe [:window-size :width])
        search-bar-visible? (if (<= window-width 768) @search-bar-active? true)
        keypad-props @(rf/subscribe [:keypad "navbar-search-bar-input"])]
    [:div.navbar-item
     {:style {:display "flex"
              :align-items "center"
              :justify-content "center"}}
     [:div.search-bar-button
      [glowing-icon-button
       {:icon (if search-bar-visible? :i.fas.fa-bars :i.fas.fa-search)
        :on-click #(do
                     (reset! search-bar-active? (not @search-bar-active?))
                     (async/go
                       (async/<! (async/timeout 50))
                       (when-let [element (js/document.getElementById "navbar-search-bar-input")]
                         (.focus element))))}]]
     [:div.search-bar.is-collapsible-width
      {:class (if search-bar-visible? "is-active" "is-collapsed-width")
       :style {:overflow "unset"}}
      [:div.field.has-addons
       [:div.control.is-expanded
        [input/input
         {:id "navbar-search-bar-input"
          :type "text"
          :placeholder "Search"
          :value (:input keypad-props)
          :on-key-up (fn [event]
                       (when (or (= event.key "Enter") (= event.keyCode 13))
                         (rf/dispatch [:assoc-in [:main-search] (:input keypad-props)])))
          :on-change #(rf/dispatch [:keyboard-button-press
                                    {:keypad-id "navbar-search-bar-input"
                                     :input (-> % .-target .-value)}])}]]
       [:div.control
        [button/button
         {:style {:width "5rem"}
          :on-click #(rf/dispatch [:assoc-in [:main-search] (:input keypad-props)])}
         [icon
          [:i.fas.fa-search
           {:aria-hidden true}]]]]]]]))


(defn top-navbar [& [props]]
  (let [window-width @(rf/subscribe [:window-size :width])
        make-space-for-search-bar? (when (<= window-width 768) @search-bar-active?)
        window-scroll @(rf/subscribe [:window-scroll])
        scrolling-down? (> (:scroll-y window-scroll) (:previous-scroll-y window-scroll))]
    [:nav.navbar.is-fixed-top.has-shadow.has-left-side-panel.slide-in-top
     {:id "top-navbar"
      :role "navigation" :aria-label "main navigation"
      :class (str (when (or @dynamic-label-active? @side-panel-focused?) " left-is-active ")
               (when-not (or (not @dynamic-side-panel-hidden?) @side-panel-focused?) " left-is-not-visible "))
      :style {:width "100%"
              :display "flex"
              :padding-bottom 0
              :align-items "center"
              :justify-content "space-between"
              :padding-left (when @dynamic-side-panel-hidden? "var(--side-panel-minimized-width)")
              "--slide-in-top-opacity-start" "1"
              "--slide-in-top-translateY" "calc(var(--side-panel-fullwidth) * -1)"
              "--slide-in-top-translateY-end" "0"
              :animation-fill-mode "backwards"
              :transform (if scrolling-down?
                           "translateY(calc((1rem + var(--navbar-height)) * -1))"
                           "translateY(0)")}}
     (when @dynamic-side-panel-hidden?
       [:div.box.side-panel-hamburger.is-left.slide-in-right
        {:style {:padding 0
                 :margin 0
                 :box-shadow "none"
                 :z-index "32"
                 "--slide-in-right-opacity-start" "1"
                 "--slide-in-right-translateX" "calc(var(--side-panel-fullwidth) * -1)"
                 "--slide-in-right-translateX-end" "0"}}
        [hamburger
         {:aria-expanded (if @dynamic-side-panel-hidden? "false" "true")
          :disabled (> window-width 768)
          :class (str "hamburger-elastic " (when-not @dynamic-side-panel-hidden? " is-active "))
          :on-click #(do (reset! dynamic-side-panel-hidden? (not @dynamic-side-panel-hidden?))
                         (css/animating :side-panel true)
                         (reset! side-panel-focused? false))}]])
     [:div.navbar-brand.is-collapsible-width
      {:class (when make-space-for-search-bar? "is-collapsed-width")
       :style {:display "flex"
               :align-items "center"
               :overflow "unset"}}
      [:button.is-clickable.navbar-item
       {:style {:padding-left "0.5rem"
                :margin-left "0.25rem"
                :border-radius "0.25rem"}
        :on-click #(rf/dispatch [:select-view :home])}
       [app-logo
        {:style {:opacity (if make-space-for-search-bar? 0 1)
                 :transition "opacity 250ms ease"}}]
       [:h5.title.is-5.navbar-brand-title
        {:style {:text-indent (if make-space-for-search-bar? "-50rem" "initial")
                 :overflow "hidden"
                 :max-height "3.25rem"
                 :margin-left "0.25rem"
                 :transition (css/style-transition "text-indent")}}
        "Game Core"]]]
     [:div.is-collapsible-width
        {:class (when make-space-for-search-bar? "is-collapsed-width")
         :style {:display "flex"
                 :align-items "center"
                 :overflow "unset"}}
        [:div.navbar-item
         {:style {:display "flex"
                  :align-items "center"}}
         [glowing-icon-button
          {:icon :i.fas.fa-user-cog
           :aria-label "User settings"
           :class (when (:user-settings @dynamic-right-side-panel-active?)
                    "is-success")
           :on-click #(do (css/animating :side-panel true)
                          (reset! dynamic-right-side-panel-active?
                                  {:user-settings (not (:user-settings @dynamic-right-side-panel-active?))}))}]]
        #_[:div.navbar-item
         {:style {:display "flex"
                  :align-items "center"}}
         [glowing-icon-button
          {:icon :i.fas.fa-bell
           :aria-label "Notifications"
           :class (when (:notifications @dynamic-right-side-panel-active?)
                    "is-success")
           :on-click #(do (css/animating :side-panel true)
                          (reset! dynamic-right-side-panel-active?
                                  {:notifications (not (:notifications @dynamic-right-side-panel-active?))}))}]]
        #_[:div.navbar-item
         {:style {:display "flex"
                  :align-items "center"}}
         [glowing-icon-button
          {:icon :i.fas.fa-sign-out-alt
           :aria-label "Sign out"
           :on-click #(rf/dispatch [:dispatch-many
                                    [[:dispatch [:assoc-in [:login] nil]]
                                     [:dispatch [:assoc-in [:login :logged-in?] false]]
                                     [:dispatch [:select-view :login]]]])}]]]]))

(defn bottom-navbar [& [props]]
  (let [window-width @(rf/subscribe [:window-size :width])]
    [:nav.navbar.is-fixed-bottom-touch.has-shadow
     {:id "bottom-navbar"
      :role "navigation" :aria-label "main navigation"
      :class (when (<= window-width 1023) "slide-in-top")
      :style {:z-index 33
              :width "100%"
              :display "flex"
              :padding-bottom 0
              :align-items "center"
              :justify-content "center"
              "--slide-in-top-opacity-start" "1"
              "--slide-in-top-translateY" "var(--side-panel-fullwidth)"
              "--slide-in-top-translateY-end" "0"
              :animation-fill-mode "backwards"}}
     #_[:div.navbar-item
      {:style {:display "flex"
               :align-items "center"}}
      [glowing-icon-button
       {:icon :i.fas.fa-user-cog
        :aria-label "User settings"
        :class (when (:user-settings @dynamic-right-side-panel-active?)
                 "is-success")
        :on-click #(do (css/animating :side-panel true)
                       (reset! dynamic-right-side-panel-active?
                         {:user-settings (not (:user-settings @dynamic-right-side-panel-active?))}))}]]
     (when (routes/supports-push-state?)
       [:div.navbar-item
        {:style {:display "flex"
                 :align-items "center"}}
        [glowing-icon-button
         {:icon :i.fas.fa-arrow-left.fa-lg
          :aria-label "Navigate back"
          :style {:opacity (if (routes/can-go-back?) "1" "0.5")}
          :disabled (not (routes/can-go-back?))
          :on-click #(routes/back)}]])
     [:div.navbar-item
      {:style {:display "flex"
               :align-items "center"}}
      [glowing-icon-button
       {:icon :i.fas.fa-home.fa-2x
        :aria-label "User settings"
        :style {:width "5rem"
                :height "5rem"
                :background "var(--background)"
                :border "2px solid var(--primary-brand-color)"
                :border-radius "50%"}
        :button-style {:width "5rem"
                       :height "5rem"
                       :color "var(--text)"
                       :border-radius "50%"}
        :on-click #(rf/dispatch [:select-view :home])}]]
     (when (routes/supports-push-state?)
       [:div.navbar-item
        {:style {:display "flex"
                 :align-items "center"}}
        [glowing-icon-button
         {:icon :i.fas.fa-arrow-right.fa-lg
          :aria-label "Navigate forward"
          :style {:opacity (if (routes/can-go-forward?) "1" "0.5")}
          :disabled (not (routes/can-go-forward?))
          :on-click #(routes/forward)}]])
     #_[:div.navbar-item
      {:style {:display "flex"
               :align-items "center"}}
      [glowing-icon-button
       {:icon :i.fas.fa-bell
        :aria-label "Notifications"
        :class (when (:notifications @dynamic-right-side-panel-active?)
                 "is-success")
        :on-click #(do (css/animating :side-panel true)
                       (reset! dynamic-right-side-panel-active?
                         {:notifications (not (:notifications @dynamic-right-side-panel-active?))}))}]]
     #_[:div.navbar-item
      {:style {:display "flex"
               :align-items "center"}}
      [glowing-icon-button
       {:icon :i.fas.fa-sign-out-alt
        :aria-label "Sign out"
        :on-click #(rf/dispatch [:dispatch-many
                                 [[:dispatch [:assoc-in [:login] nil]]
                                  [:dispatch [:assoc-in [:login :logged-in?] false]]
                                  [:dispatch [:select-view :login]]]])}]]]))

(defonce side-panel-width (r/atom nil))

(defn box-notification-date-icon [& [props]]
  [:div.media
   [:div.icon-text
    {:style {:align-items "center"}}
    [:span.icon
     (when (map? props) props)
     [:i.fas.fa-info-circle]]
    [:span
     (into
      [:small]
      (r/children (r/current-component)))]]])

(defonce show-text? (r/atom nil))

(defonce text-overflowed? (r/atom nil))

(defn element-overflow [id]
  (let [element (js/document.getElementById id)]
    (when-not (get @show-text? id)
      (swap! text-overflowed? assoc id
             (or (> element.scrollWidth element.clientWidth)
                 (> element.scrollHeight element.clientHeight))))))

(defn more-or-less-text [& [props]]
  (r/create-class
   {:component-did-mount
    (fn [] (element-overflow (str (:id props) "-text")))
    :component-did-update
    (fn [] (element-overflow (str (:id props) "-text")))
    :display-name "more-or-less-text"
    :reagent-render
    (fn [props]
      (let [window-width (rf/subscribe [:window-size :width])
            window-height (rf/subscribe [:window-size :height])
            show? (get @show-text? (str (:id props) "-text"))]
        [:div
         {:class (:class props)
          :style {:display "block"}}
         [:p
          {:id (str (:id props) "-text")
           :class (when-not show? "text-overflow")
           :style {:display "inline"
                   :max-height @window-height
                   :max-width @window-width}}
          (:text props)]
         [:button.button.is-small
          {:style {:display (if (get @text-overflowed? (str (:id props) "-text")) "block" "none")}
           :on-click #(swap! show-text? assoc (str (:id props) "-text") (not show?))}
          (if show?
            "Less"
            "More")]]))}))

(defn notification-box [& [props]]
  [:div.box.zero-border-radius
   [:div.media.is-justify-content-space-between
    [:p [:strong (:title props)]]
    [:button.is-clickable.glows
     {:type "button"
      :on-focus (:on-focus props)
      :on-click (:on-click props)
      :style {:padding 0
              :width "auto"
              :box-shadow "none"}}
     [:span.icon
      [:i.fas.fa-times-circle]]]]
   [more-or-less-text
    {:class "media"
     :id (:id props)
     :text (:text props)}]
   [box-notification-date-icon
    {:class (:class props)}
    (:date props)]])

(defn dynamic-right-side-panel-notifications []
  [:aside.side-panel
   {:class (str " box is-right " (when (:notifications @dynamic-right-side-panel-active?) " is-active "))
    :style {:padding-top "3.5rem"
            :z-index "29"}}
   [delete-cross-arrow
    {:aria-expanded (if (:notifications @dynamic-right-side-panel-active?) "true" "false")
     :class (str "is-left " (when-not (:notifications @dynamic-right-side-panel-active?) "is-active"))
     :on-click #(do (css/animating :side-panel true)
                    (reset! dynamic-right-side-panel-active?
                            {:notifications (not (:notifications @dynamic-right-side-panel-active?))}))
     :on-focus #(do (css/animating :side-panel true)
                    (reset! dynamic-right-side-panel-active? {:notifications true}))}]
   [:div
    {:style {:width "100%"
             :height "100%"}}
    [notification-box
     {:title "Long title for a notification"
      :text "This is a notification text message. This is a notification text message. This is a notification text message."
      :date "3 weeks ago"
      :id "1"
      :class "has-text-success"
      :on-focus #(do (css/animating :side-panel true)
                     (reset! dynamic-right-side-panel-active? {:notifications true}))}]
    [notification-box
     {:title "Venue"
      :text "This is a notification text message. This is a notification text message."
      :date "3 weeks ago"
      :id "2"
      :class "has-text-warning"
      :on-focus #(do (css/animating :side-panel true)
                     (reset! dynamic-right-side-panel-active? {:notifications true}))}]
    [notification-box
     {:title "User"
      :text "This is a notification text message."
      :date "3 weeks ago"
      :id "3"
      :class "has-text-info"
      :on-focus #(do (css/animating :side-panel true)
                     (reset! dynamic-right-side-panel-active? {:notifications true}))}]
    [notification-box
     {:title "Machine"
      :text "This is a notification text message."
      :date "3 weeks ago"
      :id "4"
      :class "has-text-danger"
      :on-focus #(do (css/animating :side-panel true)
                     (reset! dynamic-right-side-panel-active? {:notifications true}))}]]])

(defn dynamic-right-side-panel-user-settings []
  [:aside.side-panel
   {:class (str " box is-right " (when (:user-settings @dynamic-right-side-panel-active?) " is-active "))
    :style {:padding-top "3.5rem"
            :z-index "29"}}
   [delete-cross-arrow
    {:aria-expanded (if (:user-settings @dynamic-right-side-panel-active?) "true" "false")
     :class (str "is-left " (when-not (:user-settings @dynamic-right-side-panel-active?) "is-active"))
     :on-click #(do (css/animating :side-panel true)
                    (reset! dynamic-right-side-panel-active? {:user-settings (not @dynamic-right-side-panel-active?)}))
     :on-focus #(do (css/animating :side-panel true)
                    (reset! dynamic-right-side-panel-active? {:user-settings true}))}]
   [:aside.menu
    {:style {:overflow-y "auto"
             :overflow-x "hidden"
             :width "100%"
             :padding " 0"}}
    [dynamic-menu-label
     {:active? @dynamic-right-side-panel-active?
      :class "subtitle"
      :style {:margin "1rem 0 0 0"}}
     "Theme settings"]
    [dynamic-menu-label
     {:active? @dynamic-right-side-panel-active?}
     (str "Current theme: " (name (css/theme)))]
    [:ul.menu-list
     [:li
      [button/button
       {:class (str "is-fullwidth is-outlined" (if (= (css/theme) :dark) " is-success "))
        :on-click (fn [] (css/set-theme :dark))
        :on-focus #(do (css/animating :side-panel true)
                       (reset! dynamic-right-side-panel-active? {:user-settings true}))}
       "Dark theme"]]
     [:li
      [button/button
       {:class (str "is-fullwidth is-outlined" (when (= (css/theme) :light) " is-success "))
        :on-click (fn [] (css/set-theme :light))
        :on-focus #(do (css/animating :side-panel true)
                       (reset! dynamic-right-side-panel-active? {:user-settings true}))}
       "Light theme"]]
     [:li
      [button/button
       {:class (str "is-fullwidth is-outlined" (when (= @css/user-selected-theme :system) " is-info "))
        :on-click (fn [] (css/set-theme :system))
        :on-focus #(do (css/animating :side-panel true)
                       (reset! dynamic-right-side-panel-active? {:user-settings true}))}
       "System theme"]]]]])

(defonce side-panel-touch (r/atom {}))

(defn dynamic-side-panel [& [props]]
  (let [side-panel-focus-or-active? (or @dynamic-label-active? @side-panel-focused?)
        side-panel-visible? (or (not @dynamic-side-panel-hidden?) @side-panel-focused?)
        window-width @(rf/subscribe [:window-size :width])
        close-open-panel-fn #(do (reset! dynamic-label-active?
                                   (if (and (not @side-panel-focused?) (not @dynamic-label-active?))
                                     true
                                     false))
                                 (css/animating :side-panel true)
                                 (reset! side-panel-focused? false)
                                 (reset! dynamic-side-panel-hidden? false))]
    [:aside.side-panel.slide-in-right.has-navbar-fixed-bottom-touch
     {:class (str " box has-side-panel-hamburger is-left "
               (when side-panel-focus-or-active? " is-active ")
               (when-not side-panel-visible? " is-not-visible "))
      :style {"--slide-in-right-opacity-start" "1"
              "--slide-in-right-translateX" "calc(var(--side-panel-fullwidth) * -1)"
              "--slide-in-right-translateX-end" "0"}
      :on-touch-start (fn [event]
                        (swap! side-panel-touch assoc :start-x (.-screenX (first (.-changedTouches event)))))
      :on-touch-move (fn [event]
                       (swap! side-panel-touch assoc :move-x (.-screenX (first (.-changedTouches event)))))
      :on-touch-end (fn [event]
                      (when (and (:move-x @side-panel-touch) (:start-x @side-panel-touch)
                              (> (Math/abs (- (:move-x @side-panel-touch) (:start-x @side-panel-touch)))
                                (Math/min (* 0.2 window-width) 80)))
                        (close-open-panel-fn))
                      (reset! side-panel-touch {}))}
     [arrow-button
      {:active? side-panel-focus-or-active?
       :on-click close-open-panel-fn}]
     [:div.box.side-panel-hamburger.is-left.slide-in-right
      {:style {:padding 0
               :margin 0
               :box-shadow "none"
               :z-index "32"
               :left "calc(var(--side-panel-fullwidth) - var(--side-panel-minimized-width))"
               "--slide-in-right-opacity-start" "1"
               "--slide-in-right-translateX" "calc(var(--side-panel-fullwidth) * -1)"
               "--slide-in-right-translateX-end" "0"}}
      [hamburger
       {:aria-expanded (if @dynamic-side-panel-hidden? "false" "true")
        :disabled (or (> window-width 768) @dynamic-side-panel-hidden?)
        :class (str "hamburger-elastic " (when-not @dynamic-side-panel-hidden? " is-active "))
        :on-click #(do (reset! dynamic-side-panel-hidden? (not @dynamic-side-panel-hidden?))
                       (css/animating :side-panel true)
                       (reset! side-panel-focused? false))}]]
     [:aside.menu
      {:style {:overflow-y "auto"
               :overflow-x "hidden"
               :width "100%"
               :padding "1rem 0"}}
      #_[dynamic-menu-label
         {:active? side-panel-focus-or-active?}
         "General"]
      #_[:ul.menu-list
         [:li
          [dynamic-icon-label
           {:active? side-panel-focus-or-active?
            :icon :i.fas.fa-home
            :on-click #(rf/dispatch [:select-view :home])}
           "Home"]]
         [:li
          [dynamic-icon-label
           {:active? side-panel-focus-or-active?
            :icon :i.fas.fa-map-marked-alt
            :on-click #(rf/dispatch [:select-view :dashboard])}
           "Dashboard"]]]
      [dynamic-menu-label
       {:active? side-panel-focus-or-active?}
       "Administration"]
      [:ul.menu-list
       #_[:li
          [dynamic-icon-label
           {:active? side-panel-focus-or-active?
            :icon :i.fas.fa-flag
            :disabled true
            :on-click #(rf/dispatch [:select-view :countries])}
           "Countries"]]
       #_[:li
          [dynamic-icon-label
           {:active? side-panel-focus-or-active?
            :icon :i.fas.fa-city
            :disabled true
            :on-click #(rf/dispatch [:select-view :cities])}
           "Cities"]]
       #_[:li
          [dynamic-icon-label
           {:active? side-panel-focus-or-active?
            :icon :i.fas.fa-building
            :on-click #(rf/dispatch [:select-view :venues])}
           "Venues"]]
       #_[:li
        [dynamic-icon-label
         {:active? side-panel-focus-or-active?
          :icon :i.fas.fa-desktop
          :on-click #(rf/dispatch [:select-view :machines])
          :on-focus #(do (css/animating :side-panel true)
                         (reset! side-panel-focused? true))}
         "Machines"]
        [dynamic-ul
         {:active? side-panel-focus-or-active?
          :class (when-not side-panel-focus-or-active? "is-collapsed")}
         [:li [dynamic-icon-label
               {:active? side-panel-focus-or-active?
                :icon :i.fas.fa-crosshairs
                :disabled true
                :on-click #(rf/dispatch [:select-view :machines {:sub-view :actions}])}
               "Actions"]]
         [:li [dynamic-icon-label
               {:active? side-panel-focus-or-active?
                :icon :i.fas.fa-book
                :disabled true
                :on-click #(rf/dispatch [:select-view :machines {:sub-view :information}])}
               "Information"]]
         [:li [dynamic-icon-label
               {:active? side-panel-focus-or-active?
                :icon :i.fas.fa-cog
                :on-click #(rf/dispatch [:select-view :machines {:sub-view :settings}])}
               "Settings"]]]]
       [:li
        [dynamic-icon-label
         {:active? side-panel-focus-or-active?
          :icon :i.fas.fa-desktop
          :on-click #(rf/dispatch [:select-view :machines])}
         "Machines"]
        [dynamic-ul
         {:active? side-panel-focus-or-active?}
         [:li [dynamic-icon-label
               {:active? side-panel-focus-or-active?
                :inner-icon-label? true
                :icon :i.fas.fa-crosshairs
                :disabled true
                :on-click #(rf/dispatch [:select-view :machines {:sub-view :actions}])}
               "Actions"]]
         [:li [dynamic-icon-label
               {:active? side-panel-focus-or-active?
                :inner-icon-label? true
                :icon :i.fas.fa-book
                :on-click #(rf/dispatch [:select-view :machines {:sub-view :information}])}
               "Information"]]
         [:li [dynamic-icon-label
               {:active? side-panel-focus-or-active?
                :inner-icon-label? true
                :icon :i.fas.fa-cog
                :disabled true
                :on-click #(rf/dispatch [:select-view :machines {:sub-view :settings}])}
               "Settings"]]]]
       [dynamic-menu-label
          {:active? side-panel-focus-or-active?}
          "Games"]
       [:ul.menu-list
          [:li
           [dynamic-icon-label
            {:active? side-panel-focus-or-active?
             :icon :i.fas.fa-flag-checkered
             :on-click #(rf/dispatch [:select-view :leaderboard])}
            "Leaderboard"]]]]]]))

(defonce modal-props (r/atom {}))

(defn modals []
  [:div
   {:class (str (when (:active? @modal-props) " is-active ") " modal ")}
   [:div
    {:class (str (when (:animate-in? @modal-props) " fade-in ")
                 (when (:animate-out? @modal-props) " fade-out ")
                 " modal-background ")
     :on-click #(do (reset! modal-props {:animate-out? true
                                         :active? true})
                    (async/go
                      (async/<! (async/timeout 500))
                      (reset! modal-props {})))}]
   [:div
    {:class (str (when (:animate-in? @modal-props) " fade-in-top ")
                 (when (:animate-out? @modal-props) " fade-out-bottom ")
                 " modal-card ")}
    [:header.modal-card-head
     [:p.modal-card-title
      (:country @modal-props)]
     [:span.icon.is-clickable
      {:aria-label "close"
       :style {:font-size "1.75rem"}
       :on-click #(do (reset! modal-props {:animate-out? true
                                           :active? true})
                      (async/go
                        (async/<! (async/timeout 500))
                        (reset! modal-props {})))}
      [:i.fas.fa-times-circle]]]
    [:section.modal-card-body
     [:svg
      {:viewBox "0 0 1010.33 1010.33"}
      [:path.land {:d (:high-res (get svg-map-paths (:country-id @modal-props)))}]]]
    [:footer.modal-card-foot
     [:button.button.is-success
      "Save changes"]
     [:button.button
      "Cancel"]]]])

(defn default []
  (let [initialized? @(rf/subscribe [::bec-net/initialized?])
        [active-view] @(rf/subscribe [:active-view])
        initialized-and-logged-in? (and initialized? (not (= active-view :login)))]
    [:div#application-wrapper.fade-in
     [error-modal/main]
     (when initialized-and-logged-in?
       [:div
        #_[dynamic-right-side-panel-notifications]
        [dynamic-right-side-panel-user-settings]
        [top-navbar]
        [dynamic-side-panel]
        [bottom-navbar]
        [modals]])
     (into
      (into
       [:div.has-left-side-panel.has-navbar-fixed-bottom-touch
        {:class (str
                 (when-not (= active-view :dashboard)
                   " has-right-side-fullwidth-panel ")
                 (when (or @dynamic-label-active? @side-panel-focused?) " left-is-active ")
                 (when-not (or (not @dynamic-side-panel-hidden?) @side-panel-focused?) " left-is-not-visible ")
                 (when (or (:user-settings @dynamic-right-side-panel-active?)
                           (:notifications @dynamic-right-side-panel-active?))
                   " right-is-active "))
         :on-transition-end #(css/animating :side-panel false)
         :style (merge
                 (if initialized-and-logged-in?
                   {:padding-top "3.5rem"}
                   {:padding 0})
                 {:display "flex"
                  :justify-content "space-between"
                  :flex-direction "column"})
         :on-click #(do (when (or (:user-settings @dynamic-right-side-panel-active?)
                                  (:notifications @dynamic-right-side-panel-active?)
                                  @side-panel-focused?)
                          (css/animating :side-panel true))
                        (reset! side-panel-focused? false)
                        (reset! dynamic-right-side-panel-active? {}))}]
       (r/children (r/current-component)))
      #_[[:footer.footer
          [:div.content.has-text-centered
           [:p
            [:strong "Bulma"]
            " by "
            [:a {:href "https://jgthms.com"} "Jeremy Thomas"]
            ". The source code is licensed "
            [:a {:href "http://opensource.org/licenses/mit-license.php"} "MIT"]
            ". The website content is licensed "
            [:a {:href "http://creativecommons.org/licenses/by-nc-sa/4.0/"} "CC BY NC SA 4.0"] "."]]]])]))
